import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-recommend",
  "use": "icon-recommend-usage",
  "viewBox": "0 0 1000 1000",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1000 1000\" id=\"icon-recommend\">\r\n<metadata> Svg Vector Icons : http://www.sfont.cn </metadata>\r\n<g><path d=\"M334.4,10c-104.7,0-189.5,84.8-189.5,189.5V990h5.2l101.3-80.8L500,710.6l248.6,198.5L849.9,990h5.2V10H334.4z M640.6,553.1L500,455.3l-140.5,97.8l49.6-163.9L272.6,285.8l171.2-3.4L500,120.6l56.3,161.7l171.1,3.4L591,389.2L640.6,553.1z\" /></g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol